import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgGateOut = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path d="M10 2h4v7h-4V2ZM6 8l-4 4 4 4v-3h10a1 1 0 1 0 0-2H6V8ZM14 15h-4v7h4v-7Z" />
  )
export default SvgGateOut
